import { Component, Link } from "@mna/react";
import Clinics from "features/Clinics";
import PopupModel from "features/PopupModel";
import { Trans } from "react-i18next";
import { careOptions } from "../../../server/triage/constants";

export default class NormalSessionResults extends Component {
  render() {
    const { state, actions, history, previousStepName, nextStepName } =
      this.props;
    const { sessionResults = {} } = state.triageResponse;

    const { markers = [], clinics = [] } = sessionResults;
    const facilityName = localStorage.getItem("careoption");
    const customStyles = {
      content: {
        top: "50%",
        left: "44%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    const customStylesMobile = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    const customStyles1 = {
      content: {
        top: "20%",
        left: "50%",
        right: "50%",
        bottom: "60%",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    return (
      <div id="map" style={{ height: "100%" }}>
        <Clinics
          {...{
            state,
            actions,
            history,
            clinics,
            markers,
            header: (
              <div className="map-header-box-container bg-fa mw-100">
                <div className="pb-1">
                  <h1 className="m-0 pt-1">
                    <Trans i18nKey={facilityName}></Trans>
                  </h1>

                  <p className="hide md-show m-0 pt-1 color-dark-gray text-center text-small">
                    {!clinics[0] ? (
                      <>
                        <Trans i18nKey="findcareoption.Careoptions.housevisit.RecommendedCareOptionsheading1">
                          We could not find a matching service.
                        </Trans>{" "}
                        <a
                          onClick={() => {
                            history.push("/find-care-options/care-options");
                          }}
                        >
                          <Trans i18nKey="findcareoption.Careoptions.housevisit.RecommendedCareOptionsheading2">
                            Please select a different care option.
                          </Trans>
                        </a>
                      </>
                    ) : (
                      "Please select one of the services below."
                    )}
                  </p>
                </div>
                {/* <div className="map-header-box mt-2 py-0 text-center w-100">
            <h4 className="m-0 py-1">Care Options Result</h4>
          </div> */}
              </div>
            ),
          }}
        />

        <PopupModel
          isOpen={
            clinics.length == 0 &&
            state.msg !=
              "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen."
              ? true
              : state.msg ==
                "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen."
              ? true
              : false
          }
          style={
            clinics.length == 0 &&
            state.msg !=
              "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen."
              ? window.innerWidth <= 834
                ? customStylesMobile
                : customStyles
              : state.msg ==
                "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen."
              ? customStyles1
              : ""
          }
          modelContent={
            state.triageRequest.selectedCareOptionName ===
            careOptions.Telemedicine ? (
              <Trans i18nKey="findcareoption.Careoptions.housevisit.pharmacymsg"></Trans>
            ) : clinics.length == 0 &&
              state.msg !=
                "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen." ? (
              <div>
                <Trans i18nKey="findcareoption.Careoptions.housevisit.RecommendedCareOptionsMsg1"></Trans>{" "}
                <Trans i18nKey="findcareoption.Careoptions.housevisit.RecommendedCareOptionsMsg2"></Trans>
              </div>
            ) : state.msg ==
              "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen." ? (
              <Trans i18nKey="findcareoption.Careoptions.housevisit.pharmacyservicemsg"></Trans>
            ) : (
              ""
            )
          }
          buttonLabel={
            <Trans i18nKey="findcareoption.Covid.Continue_text">Continue</Trans>
          }
          buttonStyle="button standby-button standby-button-gradient standby-button-gradient-green"
          buttonType="button"
          onClick={() => {
            state.triageRequest.activeMenu = "care-options";
            state.triageRequest.selectedCareOptionName ===
            careOptions.Telemedicine && !state.isTravelAid2
              ? history.push(`/find-care-options/telemed-confirm-screen`)
              : clinics.length == 0 &&
                state.msg !=
                  "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen."
              ? history.push(`/find-care-options/care-options`)
              : state.msg && !state.isTravelAid2 ==
                "Sorry this service is currently not available, please  proceed' -> have continue button to proceed to the next screen."
              ? history.push(`/find-care-options/telemed-confirm-screen`)
              : history.push(`/find-care-options/done`);
          }}
        ></PopupModel>
      </div>
    );
  }
}
